<template>
<div class="container">
 <v-main>
  <v-container fluid>
   <v-row>
    <v-col>
     <SectionList 
        :RaceId="$route.params.id"
        :SectionIndex="SectionIndex" 
     />
    </v-col>
   </v-row>
  </v-container>
 </v-main>
 <SGSNotificationConfirm 
    v-if="dialog" 
    :notificationMessage="$t('common.confirm-exit')"
    @cancel="closeExit" 
    @agree="confirmExit" 
    type='warning' 
    :acept="$t('common.form.yes')"
    :reject="$t('common.form.no')" 
  />
  <SGSNotificationAlert 
    v-if="dialogAlert" 
    :notificationMessage="alertMessage" 
    @cancel="dialogAlert = false"
    type='error' 
  />
</div>
</template>

<script>
import { apiCalls } from "@/mixins/apiCalls.js";
import SectionList from "@/components/section-editor/SectionList.vue";
import SGSNotificationConfirm from "@/components/custom/notification/NotificationConfirm.vue";
import SGSNotificationAlert from "@/components/custom/notification/NotificationAlert.vue";

export default {
 mixins: [apiCalls], //for api redundant operations
 components: {
  SectionList, SGSNotificationConfirm, SGSNotificationAlert
 },
 data() {
  return {
   SelectedSection: [],
   SectionIndex: 0,
   isSeriesSelected: false,
   dialog: false,
   dialogAlert: false,
   alertMessage: '',
   leaveRoute: null
  };
 },
 computed: {
    SectionsUpdate() {
      return this.$store.getters.getSectionsUpdate;
    },
    activeMessageConfirmation() {
      return this.$store.getters.getActiveMessageConfirmation;
    },
    nextUrl() {
      return this.$store.getters.getNextUrl;
    }
 },
 methods: {
    async confirmExit() {
      if(this.SectionsUpdate.length > 0) {
        let data = {
          raceId: this.$route.params.id,
          sections: this.SectionsUpdate
        };
        const response = await this.api("put","/api/v1/promoter/section/race", data); 
        
        if(response) {
          this.dialog = false;
          if(this.activeMessageConfirmation) {
            let url = this.nextUrl;
            this.$store.commit('setActiveMessageConfirmation', false);
            this.$store.commit('setNextUrl', '');
            window.removeEventListener('beforeunload', this.confirmSaveExit);
            window.location.href = url;
          } else {
            this.leaveRoute();
          } 
        } else {
          this.$store.commit('setActiveMessageConfirmation', false);
          this.$store.commit('setNextUrl', '');
          this.dialogAlert = true;
        }
      }
    },
    closeExit() {
      if(this.activeMessageConfirmation) {
          let url = this.nextUrl;
          this.$store.commit('setActiveMessageConfirmation', false);
          this.$store.commit('setNextUrl', '');
          window.removeEventListener('beforeunload', this.confirmSaveExit);
          window.location.href = url;
      } else {
          this.leaveRoute();
      } 
    },
    confirmSaveExit(event) {
      event.preventDefault();
      event.returnValue = this.$t("common.changes-not-saved");
      return undefined;
    }
 },
 beforeRouteLeave(to, from, next) {
    if(this.SectionsUpdate.length > 0) {
      window.removeEventListener('beforeunload', this.confirmSaveExit);
      this.dialog = true;
      this.leaveRoute = next;
    } else {
      next();
    }
 },
 created: function () {
  this.$store.dispatch('getSectionsAction',this.$route.params.id);
 },
 mounted() {},
 watch: {
   SectionsUpdate(val) {
    if(val.length > 0) {
      window.addEventListener('beforeunload', this.confirmSaveExit);
    } else {
      window.removeEventListener('beforeunload', this.confirmSaveExit);
    }
   },
   activeMessageConfirmation(val) {
     if(val) {
      this.dialog = true;
     }
   }
 },
 beforeDestroy() {
   if(this.SectionsUpdate.length > 0) {
    this.$store.commit('setNextUrl','');
    this.$store.commit('setActiveMessageConfirmation', false);
   } else {
    window.removeEventListener('beforeunload', this.confirmSaveExit);
   }
 }
};
</script>

<style>
.squared {
 border-radius: 0 !important;
}
</style>
